import Filter from '../models/filter.model';
import FilterGroup from '../models/filter-group.model';

export default class FilterGroupFilterCombi {
    filterGroup: FilterGroup;
    filter: Filter;

    constructor(
        filterGroup: FilterGroup,
        filter: Filter
    ) {
        this.filterGroup = filterGroup;
        this.filter = filter;
    }
}
